import { useCallback } from "react";
import { createContextPersonKey } from "hooks/persons";
import { useQueryClient } from "react-query";

const tenantIdentifierKey = "TenantIdentifier";

export function useTenantStorage() {
    const queryClient = useQueryClient();

    const invalidateQueries = useCallback(async () => {
        await queryClient.invalidateQueries(createContextPersonKey());
    }, [queryClient]);

    const setTenant = useCallback(
        async (tenantIdentifier) => {
            window.localStorage.setItem(tenantIdentifierKey, tenantIdentifier);
            await invalidateQueries();
        },
        [invalidateQueries],
    );

    const clearTenant = useCallback(async () => {
        window.localStorage.removeItem(tenantIdentifierKey);
        await invalidateQueries();
    }, [invalidateQueries]);

    return { setTenant, clearTenant };
}
